// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gn-6";
export var emphasizeQuantity = "_gn-3";
export var flatBottomCorners = "_gn-5";
export var productImage = "_gn-0";
export var quantityContainer = "_gn-2";
export var tooltip = "_gn-1";
export var wrapAndEllipsesOverflow = "_gn-4";